import React, { useState, useEffect } from "react";
import Sidebar from "../../components/MasterSideBar";
import Topbar from "../../components/TopbarNav";
import AddJobPlanModal from "../../components/AddJobPostModal";
import JobListingTable from "../../components/JobListingTable";
// import ResignationTable from "../../components/resignationTable";
// import ResignationForm from "../../components/programManager/resignationForm"; // only if you want modal for submission

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Briefcase, FileText, UserCheck, Search, Filter, Plus, BarChart3,
  TrendingUp, Users, Calendar, MapPin, DollarSign, ArrowUpRight, ArrowDownRight,
  Loader2, AlertCircle, CheckCircle, Clock, Edit
} from "lucide-react";

const StatCard = ({ title, value, change, changeType, icon, iconBg, description }) => (
  <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100 hover:shadow-md transition-shadow">
    <div className="flex items-start justify-between">
      <div>
        <p className="text-sm font-medium text-gray-500 mb-1">{title}</p>
        <p className="text-2xl font-bold text-gray-900">{value}</p>
        {change && (
          <div className={`flex items-center mt-2 text-sm ${changeType === 'positive' ? 'text-green-600' : 'text-red-600'}`}>
            {changeType === 'positive' ? <ArrowUpRight className="w-4 h-4 mr-1" /> : <ArrowDownRight className="w-4 h-4 mr-1" />}
            <span>{change}</span>
          </div>
        )}
        {description && (
          <p className="text-xs text-gray-500 mt-1">{description}</p>
        )}
      </div>
      <div className={`p-3 rounded-lg ${iconBg}`}>
        {icon}
      </div>
    </div>
  </div>
);

const QuickActionCard = ({ title, description, icon, onClick, color }) => (
  <button
    onClick={onClick}
    className="bg-white rounded-xl shadow-sm p-6 border border-gray-100 hover:shadow-md transition-all hover:scale-[1.02] text-left group"
  >
    <div className={`p-3 rounded-lg ${color} mb-4 inline-block`}>
      {icon}
    </div>
    <h3 className="font-semibold text-gray-900 mb-1 group-hover:text-orange-600 transition-colors">{title}</h3>
    <p className="text-sm text-gray-500">{description}</p>
  </button>
);

export default function RecruitmentPage() {
  const [activeTab, setActiveTab] = useState('jobListings');
  const [showJobPlanModal, setShowJobPlanModal] = useState(false);
  const [jobTableRefresh, setJobTableRefresh] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showFilters, setShowFilters] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  const handleSaveJobPlan = (savedJob) => {
    toast.success("Job Plan added successfully.");
    setJobTableRefresh(prev => prev + 1);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  // Simulate loading data
  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 800);
    return () => clearTimeout(timer);
  }, [activeTab]);

  const renderTabContent = () => {
    if (loading) {
      return (
        <div className="flex items-center justify-center py-12">
          <Loader2 className="w-8 h-8 animate-spin text-orange-500" />
          <span className="ml-3 text-gray-600">Loading data...</span>
        </div>
      );
    }

    switch (activeTab) {
      case 'jobListings':
        return (
          <div className="p-6">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold text-gray-800">Job Listings</h2>
              <button
                onClick={() => setShowJobPlanModal(true)}
                className="flex items-center gap-2 px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors shadow-sm"
              >
                <Plus className="w-4 h-4 ml-1" />
                Add Job Posting
              </button>
            </div>
            <JobListingTable refresh={jobTableRefresh} />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-50 font-sans">
      <Sidebar onLogout={handleLogout} />
      <div className="flex-1 relative overflow-y-auto md:ml-64">
        <div className="fixed top-0 left-0 right-0 md:left-64 z-10">
          <Topbar />
        </div>
        <main className="pt-20 px-4 sm:px-6 pb-8">
          <div className="mb-8 text-center">
            <h1 className="text-4xl font-black text-gray-900 mb-2 uppercase tracking-tighter">Recruitment <span className="text-orange-600">Management</span></h1>
            <p className="text-gray-500 font-medium italic">Streamline and manage your organizational hiring workflow.</p>
          </div>

          {/* Tab Navigation */}
          <div className="bg-white rounded-xl shadow-sm p-1 mb-6 overflow-x-auto">
            <div className="flex min-w-max">
              <button
                className={`flex items-center gap-2 py-3 px-8 rounded-2xl font-black text-[10px] uppercase tracking-widest transition-all ${activeTab === 'jobListings' ? 'bg-orange-600 text-white shadow-lg shadow-orange-200' : 'text-gray-400 hover:text-gray-600 hover:bg-white'}`}
                onClick={() => setActiveTab('jobListings')}
              >
                <Briefcase className="w-4 h-4" />
                Job Listings
              </button>
            </div>
          </div>

          {/* Tab Content */}
          <div className="bg-white rounded-xl shadow-sm overflow-hidden">
            {renderTabContent()}
          </div>

          {/* Modals */}
          <AddJobPlanModal
            isOpen={showJobPlanModal}
            onClose={() => setShowJobPlanModal(false)}
            onSave={handleSaveJobPlan}
          />
        </main>
      </div>
    </div>
  );
}